module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAPCAYAAADtc08vAAABVUlEQVQokZ3TP0iWURQG8N/39VJZQUMQQipKDalBbX67jeHkHxqsXarVMCEVgqigQBtySTC3Ak0KQ6WhHMWpwalBQbRdzUEa3vPqVdCiBy7n3HPO89z3vufc0qvhN7fwBNf9BzLU4nwSq6ATjaiK2Aam8R5bhwW+4AbKGEP3EYd14AV6o44grWEVL48hF7iIt+hLBU6hGff+Qk4xgIZCoBVdWEYdSrEaEr9YZ3EHv/EZNWUMheojrIR/Ad9wOvZnwm5iHIO4indlXInkcvKJvRjBfZzALJqS/Pew17K4BuzKW1rBLzzHHM7hKW7jKxaiFkoZ1nEJl/EpuQZ52/rxWD4HBarDbpTRg504scZBzODuodhJPAj/dYaP8smbxE8sYtvRqEM9bmI+i+AU5uUtbTmGXOBZ1O/9QGjDh38gj+JhscmSxCba7T+mJvtzsIUfmMBSqvYHBHo/PjTBT+sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ocpc_icon.png
// module id = go8C
// module chunks = 1